export default "__VITE_ASSET__N06X8Bky__"